module.exports = __webpack_public_path__ + "img/jn.6e772c3a.jpg";